import { connect } from 'react-redux'
import SearchBoxComponent from '../components/SearchBoxComponent'
import DisplayActions from '../redux/DisplayRedux'

const mapStateToProps = ({ display, userAccount  }) => ({
  user: userAccount.user,
  clients: display.clients,
  client: display.client,
  loadingClients: display.loadingClients,
  brands: display.brands,
  brand: display.brand,
  loadingBrands: display.loadingBrands,
  programmatic: display.programmatic,
  amountBudget: display.amountBudget,
  mapZoom: display.mapZoom,
  audience: display.audience,
  loadingAudience: display.loadingAudience,
  currency: userAccount.currency,
  dsps: display.dsps,
  dsp: display.dsp,
  editCampaignActive: display.editCampaignActive,
  isSuperUser: userAccount.isSuperUser,
  conversionRates: display.conversionRates,
  showCampaignFormModal: display.showCampaignFormModal,
  planner: display.planner,
  proposals: display.proposals,
  loadingPlannerSkip: display.loadingPlannerSkip,
  loadingPlanner: display.loadingPlanner,
  loadingProposals: display.loadingProposals,
  optimizedBrief: display.optimizedBrief,
  loadingOptimizeBrief: display.loadingOptimizeBrief,
  campaign_categories: display.campaign_categories,
  campaign_POI: display.campaign_POI,
  campaign_screens: display.campaign_screens,
  invoiceIssuingCountry: userAccount.invoiceIssuingCountry,
  countries: userAccount.countries,
  isGuaranteed: display.isGuaranteed,
  acceptedGuaranteedTerms: display.acceptedGuaranteedTerms,
  showAllDisplays: display.showAllDisplays
})

const mapStateToDispatch = (dispatch) => ({
  resetFilters: (id) => dispatch(DisplayActions.resetFilters(id)),
  setCoords: coords => dispatch(DisplayActions.setCoords(coords)),
  setMapZoom: zoom => dispatch(DisplayActions.setMapZoom(zoom)),
  getClients: (userId) => dispatch(DisplayActions.getClientsRequest(userId)),
  setClient: (client) => dispatch(DisplayActions.setClient(client)),
  getExternalDsps: () => dispatch(DisplayActions.getExternalDspsRequest()),
  setDsp: (dsp) => dispatch(DisplayActions.setDsp(dsp)),
  clearDsp: () => dispatch(DisplayActions.clearDsp()),
  getBrands: (clientId) => dispatch(DisplayActions.getBrandsRequest(clientId)),
  setBrands: (brands) => dispatch(DisplayActions.setBrands(brands)),
  setBrand: (brand) => dispatch(DisplayActions.setBrand(brand)),
  clearBrands: (id) => dispatch(DisplayActions.clearBrands(id)),
  clearClients: (id) => dispatch(DisplayActions.clearClients(id)),
  setProgrammatic: (programmatic) => dispatch(DisplayActions.setProgrammatic(programmatic)),
  setShowAllDisplays: (showAllDisplays) => dispatch(DisplayActions.setShowAllDisplays(showAllDisplays)),
  setType: (type) => dispatch(DisplayActions.setType(type)),
  setBudget: (amountBudget) => dispatch(DisplayActions.setBudget(amountBudget)),
  getAudience: (data) => dispatch(DisplayActions.getAudienceRequest(data)),
  removeDisplaysCart: () => dispatch(DisplayActions.removeDisplaysCart()),
  getConversionRates: () => dispatch(DisplayActions.getConversionRatesRequest()),
  createPlannerRequest: (params) => dispatch(DisplayActions.createPlannerRequest(params)),
  createProposalsRequest: (plannerId, params) => dispatch(DisplayActions.createProposalsRequest(plannerId,params)),
  getCampaignCategoriesRequest: () => dispatch(DisplayActions.getCampaignCategoriesRequest()),
  getCampaignPOIRequest: () => dispatch(DisplayActions.getCampaignPOIRequest()),
  getCampaignScreensRequest: () => dispatch(DisplayActions.getCampaignScreensRequest()),
  optimizeBriefRequest: (params) => dispatch(DisplayActions.optimizeBriefRequest(params)),
  clearOptimizedBrief: () => dispatch(DisplayActions.optimizeBriefSuccess(null)),
  clearPlanner: () => dispatch(DisplayActions.clearPlanner()),
  clearProposals: () => dispatch(DisplayActions.clearProposals()),
  toggleCampaignFormModal: (visible) => dispatch(DisplayActions.toggleCampaignFormModal(visible)),
  clearCampaignData: (actionBy) => dispatch(DisplayActions.clearCampaignData(actionBy)),
  setIsGuaranteed: (isGuaranteed) => dispatch(DisplayActions.setIsGuaranteed(isGuaranteed)),
  setAcceptedGuaranteedTerms: (acceptedGuaranteedTerms) => dispatch(DisplayActions.setAcceptedGuaranteedTerms(acceptedGuaranteedTerms))
})

export default connect(mapStateToProps, mapStateToDispatch)(SearchBoxComponent)
